import { Img } from "components";
import { FeatureCard } from "./components/feature-card";

export default function AIBasedFeeCollection() {
  return (
    <main className="mx-auto max-w-6xl px-2 py-18 md:px-5 md:py-12 sm:px-4 sm:py-8">
      <header className="text-center space-y-4 sm:space-y-3">
        <h1 className="text-balance text-5xl font-semibold tracking-tight text-[#0C0C0C] md:text-3xl sm:text-2xl">
          AI‑Based Fee Collection
        </h1>
        <p className="text-xs text-[#4D4D4D] text-pretty font-medium sm:text-[11px]">
          No more fee delays or tedious follow‑ups. Get your fees on time, always!
        </p>
      </header>

      <section
        aria-label="Key features"
        className="mt-20 grid gap-4 grid-cols-3 items-stretch md:mt-12 md:grid-cols-1 md:gap-6 sm:mt-8 sm:gap-4"
      >
        {/* Left column features - Desktop only side column */}
        <div className="h-full flex flex-col gap-3 md:hidden">
          <FeatureCard
            title="Auto‑Collect"
            description="Automate recurring payments via NACHA or UPI authorizations."
            className="flex-1"
          />
          <FeatureCard
            title="Tailored Payment Options"
            description="Offer multiple ways to pay for a smooth experience for your institute and fee payers."
            className="flex-1"
          />
          <FeatureCard
            title="Customizable Fee Schedules"
            description="Define discounts, late fees, and installment plans tailored to your institute."
            className="flex-1"
          />
          <FeatureCard
            title="Automated Fee Communication"
            description="Send reminders, due notes, and receipts via WhatsApp, calls, and email."
            className="flex-1"
          />
        </div>

        {/* Center image visual */}
        <div className="md:order-1">
          <figure className="h-full rounded-xl border bg-card shadow-sm overflow-hidden flex min-h-[400px] md:min-h-[300px] sm:min-h-[250px]">
            <Img
              src="/images/new-landing-page/aiFeePayment.svg"
              alt="AI‑Based Fee Collection mobile preview"
              className="h-full w-full object-contain"
            />
          </figure>
        </div>

        {/* Right column features - Desktop only side column */}
        <div className="h-full flex flex-col gap-3 md:hidden">
          <FeatureCard
            title="Instantly‑Collect"
            description="Accept instant payments via QR codes or payment links."
            variant="right"
            className="flex-1"
          />
          <FeatureCard
            title="Real‑Time Analytics"
            description="See collections, overdue amounts, and upcoming cash flows in one dashboard."
            variant="right"
            className="flex-1"
          />
          <FeatureCard
            title="Effortless Reconciliation"
            description="Match payments with bank statements to save time and reduce errors."
            variant="right"
            className="flex-1"
          />
          <FeatureCard
            title="Ultimate Fee Management"
            description="AI‑powered for smarter, faster, and error‑free collections."
            variant="right"
            className="flex-1"
          />
        </div>

        {/* Mobile/Tablet: All features stacked below image */}
        <div className="hidden md:flex md:flex-col md:gap-3 md:order-2 sm:gap-2.5">
          <FeatureCard
            title="Auto‑Collect"
            description="Automate recurring payments via NACHA or UPI authorizations."
          />
          <FeatureCard
            title="Tailored Payment Options"
            description="Offer multiple ways to pay for a smooth experience for your institute and fee payers."
          />
          <FeatureCard
            title="Customizable Fee Schedules"
            description="Define discounts, late fees, and installment plans tailored to your institute."
          />
          <FeatureCard
            title="Automated Fee Communication"
            description="Send reminders, due notes, and receipts via WhatsApp, calls, and email."
          />
          <FeatureCard
            title="Instantly‑Collect"
            description="Accept instant payments via QR codes or payment links."
          />
          <FeatureCard
            title="Real‑Time Analytics"
            description="See collections, overdue amounts, and upcoming cash flows in one dashboard."
          />
          <FeatureCard
            title="Effortless Reconciliation"
            description="Match payments with bank statements to save time and reduce errors."
          />
          <FeatureCard
            title="Ultimate Fee Management"
            description="AI‑powered for smarter, faster, and error‑free collections."
          />
        </div>
      </section>

      <section aria-labelledby="why-title" className="mt-16 md:mt-12 sm:mt-10">
        <h2 id="why-title" className="text-center text-2xl font-semibold tracking-tight md:text-xl sm:text-lg">
          Why It Matters
        </h2>

        <div className="mt-10 grid gap-8 text-center grid-cols-3 md:mt-8 md:gap-6 sm:mt-6 sm:gap-4 sm:grid-cols-1">
          <div className="space-y-2 sm:space-y-1.5">
            <div className="text-6xl font-semibold text-[#0762D7] md:text-5xl sm:text-4xl">90%</div>
            <p className="text-xs md:text-sm text-muted-foreground font-medium sm:text-xs">
              reduction in
              <br />
              collection efforts
            </p>
          </div>

          <div className="space-y-2 sm:space-y-1.5">
            <div className="text-6xl font-semibold text-[#0762D7] md:text-5xl sm:text-4xl">100%</div>
            <p className="text-xs md:text-sm text-muted-foreground font-medium sm:text-xs">
              visibility of past and
              <br />
              upcoming fee collections
            </p>
          </div>

          <div className="space-y-2 sm:space-y-1.5">
            <div className="text-6xl font-semibold text-[#0762D7] md:text-5xl sm:text-4xl">60%</div>
            <p className="text-xs md:text-sm text-muted-foreground font-medium sm:text-xs">
              more on‑time fee
              <br />
              collection
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
